export default function generateDefaultI18nConfig() {
  return {
    detection: {
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'lng',
      lookupCookie: 'lng',
      cookieMinutes: 1000,
      order: ['localStorage', 'cookie'],
    },
    react: {
      bindI18n: 'languageChanged loaded',
      nsMode: 'default',
      // Avoid suspending the whole tree without a <Suspense> boundary (blank screen in SPA shell).
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
  };
}
